import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
import { Countdown } from './Countdown';
type CtaBlockProps = {
  label: string;
  note?: string;
  withTimer?: boolean;
  id?: string;
};
export function CtaBlock({
  label,
  note = 'Accès immédiat · Paiement unique · Garantie de 7 jours',
  withTimer = true,
  id
}: CtaBlockProps) {
  return <div id={id} className="flex flex-col items-center gap-4" data-id="element-26" data-mp="1zqc70l94wawr">
      <a href={CHECKOUT_URL} className="group relative flex w-full max-w-md items-center justify-center gap-2 rounded-xl bg-spark-500 px-5 py-4 text-center font-display text-xl uppercase leading-tight tracking-wide text-ink-950 shadow-[0_10px_30px_-8px_rgba(255,184,0,0.6)] transition-transform duration-150 ease-out hover:scale-[1.02] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-spark-400 active:scale-[0.99] sm:text-2xl" data-id="element-27" data-mp="1znzoa5vjxwin">
        <span data-id="element-28" data-mp="j9q0bcv829sc">{label}</span>
        <ArrowRightIcon className="h-5 w-5 shrink-0 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-29" data-mp="103798jvra79s" />
      </a>
      {withTimer && <Countdown size="sm" data-id="element-30" data-mp="193vqrokcyprf" />}
      {note && <p className="max-w-sm text-center text-xs font-medium text-white/50" data-id="element-31" data-mp="195oyl76pjg10">{note}</p>}
    </div>;
}